import { useTranslation } from "react-i18next";

/**
 * What a translated message is: a string.
 *
 * i18next's own `TFunction` widens its return to `string | object | null`,
 * because a catalogue *can* be asked for a whole subtree with `returnObjects`.
 * Nothing here does that - every key in `langs/*.json` resolves to a leaf - and
 * the wide type means any caller assigning a message to a `string` has to cast.
 * Narrowing it once, here, is what keeps that cast out of every game panel.
 */
export type Translate = (key: string, options?: Record<string, unknown>) => string;

export const useTranslate = (moduleKey = undefined): Translate => {
  const { t: translate } = useTranslation(moduleKey);

  return translate as Translate;
};
